<script lang="ts">
  import {project, user} from '@/store';
  import {Integration, IntegrationUser} from '@/types/integrations';
  import {onDestroy} from 'svelte';
  import {fade} from 'svelte/transition';
  import {parseIdentifier} from '../helpers';
  import Form from './Form.svelte';
  import MediaSelect from './MediaSelect';
  import {UploadSource} from '@/types/common';

  type Identifier = {
    client_id: string;
    client_secret: string;
  };

  export let integration: Integration;
  export let userIntegration: IntegrationUser | undefined;
  export let isUploadIntegrationsDialogOpen: boolean;
  export let isUploading: boolean;

  $: identifier = userIntegration?.identifier ? parseIdentifier<Identifier>(userIntegration.identifier) : undefined;

  let clientId = identifier?.client_id ?? '';
  let clientSecret = identifier?.client_secret ?? '';
  let isUpdating = false;
  let language = 'English';

  const reset = () => {
    clientId = '';
    clientSecret = '';
    isUpdating = false;
  };

  const handleClose = () => {
    reset();
    isUploadIntegrationsDialogOpen = false;
  };

  const preferencesSubscription = user.subscribe(user => {
    language = user?.preferences?.language ?? 'English';
  });

  const handleUploadVideo = async (e: CustomEvent<string>) => {
    isUploading = true;
    try {
      project.uploadYoutubeVideo({
        url: e.detail,
        language,
        source: UploadSource.RESI
      });

      handleClose();
    } catch (error) {
      console.error('stream video upload error', error);
    }
  };

  onDestroy(() => preferencesSubscription());
</script>

<div class="contents">
  <button
    on:click={() => (isUploadIntegrationsDialogOpen = false)}
    class="absolute right-3 top-3 flex items-center justify-center rounded-full px-3 py-2 hover:bg-zinc-100"
    aria-label="Close"
  >
    <i class="fa-solid fa-xmark text-lg text-gray-400"></i>
  </button>
  <div class="container p-6">
    {#if !identifier || isUpdating}
      <div class="item" transition:fade={{duration: 100}}>
        <Form
          {clientId}
          {clientSecret}
          bind:isUpdating
          bind:userIntegration
          integrationId={integration.id}
          on:close={handleClose}
        />
      </div>
    {:else}
      <div class="item" transition:fade={{duration: 100}}>
        <MediaSelect bind:isUpdating clientId={identifier?.client_id} on:select={handleUploadVideo} />
      </div>
    {/if}
  </div>
</div>

<style>
  .container {
    display: grid;
  }

  .item {
    min-width: 0;
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }
</style>
